export const Roles = {
    Operator: 'operator',
    Admin: 'admin',
    Whitelisted: 'whitelisted',
    Beneficiary: 'beneficiary',
    DefaultAdmin: 'defaultAdmin',
};
export const roles = [Roles.Operator, Roles.Admin, Roles.Whitelisted, Roles.Beneficiary, Roles.DefaultAdmin];
export const RolesMatch = {
    OneOf: 'oneOf',
    All: 'all',
};
export const managedRoles = [Roles.Operator, Roles.Admin];
//# sourceMappingURL=roles.js.map